import { Button, type ButtonProps } from "@braintrust/braintrust-ui-components";
import { ArrowTopRightIcon } from "@braintrust/braintrust-ui-components/Icons";
import { RouterLink } from "@js/components/link";

type JobActionButtonBaseProps = ButtonProps & {
  label: string;
  withIcon?: boolean;
};

export const JobActionButtonPure = ({
  label,
  withIcon,
  ...props
}: JobActionButtonBaseProps) => {
  return (
    <Button
      {...props}
      sx={{
        ...props.sx,
        flexShrink: 0,
        height: { sm: 40 },
      }}
    >
      {label}
      {withIcon && (
        <ArrowTopRightIcon
          style={{
            fontSize: props.size === "x-small" ? 16 : 24,
            marginLeft: 8,
          }}
        />
      )}
    </Button>
  );
};

export const JobActionButtonBase = ({ ...props }: JobActionButtonBaseProps) => {
  return (
    <JobActionButtonPure
      rel="noopener noreferrer"
      target="_blank"
      RouterLink={RouterLink}
      {...props}
    />
  );
};
